// src/components/viewer/CheckBreakdown.jsx

import React from 'react';

const CheckBreakdown = ({ data }) => {
    const totalFound = (data.totalUsers || 0) - (data.totalNotFound || 0);
    const riskType = (data.riskTypeGroup || 'CRP').toUpperCase();

    // Determine which checks apply based on risk type
    const showActivity = riskType === 'HRP' || riskType === 'CRP';
    const showJobLevel = riskType === 'CRP';
    const showSearchActivity = riskType === 'CRP';

    // Search count summary
    const searchSummary = data.searchCountSummary || {};
    const searchPass = searchSummary.passCount || 0;
    const searchBelow = searchSummary.belowThresholdCount || 0;
    const searchNoData = searchSummary.noDataCount || 0;
    const searchTotal = searchSummary.totalEvaluated || totalFound || 0;

    const getSearchCheckClass = () => {
        if (searchTotal === 0) return 'warning';
        if (searchBelow === 0 && searchNoData === 0) return 'pass';
        if (searchBelow > 0) return 'warning';
        return 'pass';
    };

    let checkNum = 0;

    return (
        <div className="check-breakdown">
            <div className="section-title">Validation Results ({riskType})</div>
            
            {showActivity && (
                <div className={`check-item ${(data.inactiveCount || 0) === 0 ? 'pass' : 'fail'}`}>
                    <span className="check-name">{++checkNum}️⃣ Activity Check (≤30 days inactive)</span>
                    <span className="check-result">
                        {totalFound - (data.inactiveCount || 0)}/{totalFound} passed
                    </span>
                </div>
            )}
            
            <div className={`check-item ${(data.noBasePICount || 0) === 0 ? 'pass' : 'warning'}`}>
                <span className="check-name">{++checkNum}️⃣ Base PI Access</span>
                <span className="check-result">
                    {totalFound - (data.noBasePICount || 0)}/{totalFound} have access
                </span>
            </div>
            
            {showJobLevel && (
                <div className={`check-item ${(data.lowJobLevelCount || 0) === 0 ? 'pass' : 'warning'}`}>
                    <span className="check-name">{++checkNum}️⃣ Job Level (&gt;3 for UFS)</span>
                    <span className="check-result">
                        {totalFound - (data.lowJobLevelCount || 0)}/{totalFound} eligible
                    </span>
                </div>
            )}

            {showSearchActivity && (
                <div className={`check-item ${getSearchCheckClass()}`}>
                    <span className="check-name">{++checkNum}️⃣ Search Activity (informational)</span>
                    <span className="check-result">
                        {searchTotal > 0 ? (
                            <>
                                {searchPass > 0 && (
                                    <span style={{ color: '#1a7f37', marginRight: '6px' }}>
                                        {searchPass} sufficient
                                    </span>
                                )}
                                {searchBelow > 0 && (
                                    <span style={{ color: '#d4880f', marginRight: '6px' }}>
                                        {searchBelow} low
                                    </span>
                                )}
                                {searchNoData > 0 && (
                                    <span style={{ color: '#666' }}>
                                        {searchNoData} no data
                                    </span>
                                )}
                            </>
                        ) : (
                            <span style={{ color: '#666' }}>No data available</span>
                        )}
                    </span>
                </div>
            )}
        </div>
    );
};

export default CheckBreakdown;